import React from "react";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  root: {
    marginTop: 16,
    display: "flex",
    alignItems: "flex-start"
  },
  field: {
    width: 105,
    minWidth: 105,
    paddingRight: 16,
  },
  value: {
    fontSize: 12,
  }
}));

const StateInfoField = ({ field, value }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Typography
        className={classes.field}
        variant="caption"
        color="textSecondary"
      >
        {field}
      </Typography>
      <Typography className={classes.value} variant="caption">
        {value}
      </Typography>
    </div>
  );
};

export default StateInfoField;
